import React, { Component } from 'react';
import KickImage from 'Reuseables/KickImage';
import { 
    Modal,
    ModalHeader,
    ModalBody,
    Container } from 'reactstrap';
export default class ModalSentVerifyEmailDone extends Component{
    
    render(){
        return(
            <Modal isOpen={this.props.isOpen} toggle={this.props.onToggle} className="kick-modal modal-not-verified">
                <ModalHeader toggle={this.props.onToggle}></ModalHeader>
                <ModalBody>
                    <Container>
                        <h5>EMAIL VERIFICATION</h5>
                        <p>
                            Email sent to: <strong>{this.props.email}</strong>.<br/>
                            Please check your inbox / junk / spam for an email from no-reply@kickavenue.com and click the verification link in it.
                        </p>
                    </Container>                    
                </ModalBody>
            </Modal>
        )
    }
}